import {useQuery} from 'react-query';
import {getOrderDetails} from './getOrderDetails';
import {IOrderResponse} from './types';

const useGetOrderDetails = ({
  orderGuid,
  storeOrderGuid,
}: {
  orderGuid?: string;
  storeOrderGuid?: string;
}) => {
  const {data, isLoading, refetch} = useQuery<IOrderResponse>(
    ['get-order-details', orderGuid],
    () => getOrderDetails({orderGuid, storeOrderGuid}),
    {
      enabled: Boolean(orderGuid),
    },
  );

  return {data, isLoading, refetch};
};

export default useGetOrderDetails;
